import axios from '@/api/config/request'
import { BASE_API } from './index'

/**
 * 登录类型枚举
 * 用于规范登录接口的类型参数，避免使用魔法字符串
 */
export const LoginType = Object.freeze({
  /** 手机号密码登录 */
  MOBILE_ACCOUNT: 'maccount',
  /** 手机号验证码登录 */
  MOBILE: 'mobile',
  /** 账号密码登录 */
  ACCOUNT: 'account',
  /** 易缆网多账号选择id登录 */
  ID: 'id'
})

/**
 * 根据登录类型调用对应的登录接口
 * @param {string} [type=LoginType.MOBILE] - 登录类型，来源于 LoginType 枚举，默认为手机号验证码登录
 * @param {Object} data - 登录请求参数（如 mobile, password, sim 等）
 * @returns {Promise} 返回 axios 请求的 Promise 对象
 * @throws {Error} 当传入不支持的登录类型时抛出错误
 */
export function loginByType(type = LoginType.MOBILE, data) {
  // 校验登录类型是否合法，防止传入无效的类型值导致接口404或后端异常
  const validTypes = Object.values(LoginType)
  if (!validTypes.includes(type)) {
    throw new Error(`无效的登录类型: ${type}，合法值为: ${validTypes.join(', ')}`)
  }

  return axios({
    url: `${BASE_API}/yl/login/${type}`,
    method: 'post',
    data
  })
}